import { Map } from 'leaflet';
import { FC } from 'react';

type pinV1 = {
  Text: string;
  Title: string;
  Address: string;
  Province: string;
  City: string;
  Type: string;
  FClass: string;
  Coordinate: {
    lat: number;
    lon: number;
  };
};

interface TcMapSearchResultBoxProps {
  result: pinV1;
  map?: Map;
  toggleOpen: () => void;
}

const TcMapSearchResultBox: FC<TcMapSearchResultBoxProps> = ({ result, map, toggleOpen }) => {
  //func
  const flyToMap = () => {
    map?.flyTo([result.Coordinate.lat, result.Coordinate.lon], 16);
    toggleOpen();
  };

  return (
    <div className='border-b shadow-sm  mb-2 pb-2 flex justify-between  items-center'>
      <div>
        <div className='flex items-center '>
          {result.Province && <span className='text-t-secondary-text-color text-sm pl-1'>استان {result.Province}</span>}
          {result.City && <span className='text-t-secondary-text-color  text-sm px-1'> , شهر {result.City}</span>}
        </div>
        <span className='text-base'>{result.Title}</span>
      </div>

      <span onClick={flyToMap} className='text-sm text-t-secondary-color inher cursor-pointer '>
        مشاهده نتیجه
      </span>
    </div>
  );
};

export default TcMapSearchResultBox;
